import { gql } from '@zenbusiness/application-commons-graphql';

export const BANKING_PREFERRED_ORDER_STATUS = gql`
  query BankingPreferredOrderStatus($input: OrderStatusInput!) {
    bankingPreferredOrderStatus(input: $input) {
      hasOrder
    }
  }
`;

export const EIN_ORDER_STATUS = gql`
  query EINOrderStatus($input: OrderStatusInput!) {
    einOrderStatus(input: $input) {
      hasOrder
    }
  }
`;

export const VALIDATE_APPLICATION = gql`
  query ValidateApplicationData($input: ValidateApplicationInput!) {
    validateApplication(input: $input) {
      valid
      errors {
        field
        type
        message
      }
    }
  }
`;
